import React, { useState, useEffect} from 'react';
import api from '../conexao.js';
import DOMPurify from 'dompurify';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import draftToMarkdown  from 'draftjs-to-markdown';
import htmlToPdfMake from 'html-to-pdfmake';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState,  convertToRaw, ContentState } from 'draft-js';

import cabecalho from '../../img/novo.jpg'
import rodape from '../../img/rodape.jpg'
import {Modal, Form, Button,Spinner} from 'react-bootstrap';
import logOut from '../logOut';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons"
import {faClone,faPaste} from "@fortawesome/free-solid-svg-icons"

import PrintReports from './print.js';
import { sendFile } from '../whatsApp/sendZap.js';
import pdfMake from 'pdfmake/build/pdfmake'; 
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {removeBlankLines, removeFontAttributes, convertListsToPdfMake}  from './draftToPdfMake';
import toast from 'react-hot-toast';
import { useTabProtection } from '../../hooks/useTabProtection';


pdfMake.vfs = pdfFonts.pdfMake.vfs;



export default function Atestado(props){

    const [html, setHTML] = useState('');
    const [contentBlock] = useState(htmlToDraft(html));
    const [contentState] = useState(ContentState.createFromBlockArray(contentBlock.contentBlocks));
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState));   
    
    const [textoBanco, setTextoBanco] = useState();
    const [data, setData] = useState(new Date())
    const [dataTexto, setDataTexto] = useState();

    
    const [atestado, setAtestado] = useState([]);
    const [codAtestado, setCodAtestado] = useState();
    const [texto, setTexto] = useState([]);
    const [codTexto, setCodTexto] = useState();
    const [disableData, setDisableData] = useState(false);
    const [mostraModal, setMostraModal] = useState(false);
    const [modalGravado, setModalGravado] = useState(false);
    const [modalMSG, setModalMSG] = useState(false);
    const [MSG, setMSG] = useState();
    
    const [auxStatus, setAuxStatus] = useState(false)
    
    const [btnCancelar, setBtnCancelar] = useState(false)   // botao cancelar
    const [edicao, setEdicao] = useState(false); // botao gravar

    // Integração com sistema de proteção de mudanças não salvas
    const tabKey = props.tabKey || 'atestado';
    useTabProtection(!edicao, tabKey); // !edicao porque quando edicao=false há mudanças não salvas

    const [dataBR, setDataBR] = useState(); 
    const [loading, setLoading] = useState(true)
    const [copiaAtestado,setCopiaAtestado] = useState();

    const [modalEnviar,setModalEnvia] = useState(false);
    const [botaoEnv, setBotaoEnv] = useState(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const pdfMake = require('pdfmake/build/pdfmake');
    const toolBarValues = {
        options: ["inline", "fontSize", "colorPicker", "textAlign", "list"],
        inline: {
          inDropdown: false,
          options: ["bold", "italic", "underline", "strikethrough"]
        },
        list: {
          inDropdown: false,
          options: ["unordered", "ordered"]
        }
    };
    
    function onEditorStateChange(editorState) {
        setEditorState(editorState)
        // Sanitização apenas no conteúdo bruto para performance
        setTextoBanco(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    };

    // Sanitização otimizada apenas ao salvar
    const sanitizeContent = (content) => {
        return DOMPurify.sanitize(content, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'ol', 'ul', 'li', 'span', 'div'],
            ALLOWED_ATTR: ['style'],
            ALLOW_DATA_ATTR: false
        });
    };
    
    function transformaData(d){
        var date = new Date(d)                      // converte a data ISO DateTimeStamp(como vem do banco) para DD/MM/YYYY
        date.setHours(0,0,0,0)                      // zera a hora 00:00:00
        return(date.getDate()+'/' + (date.getMonth()+1) + '/'+date.getFullYear())      
    }

    function transformaDataBanco(d){                // converte data = new Date() para DD/MM/YYYY
        var date = new Date(d)                      // converte a data ISO DateTimeStamp(como vem do banco) para DD/MM/YYYY
        date.setHours(0,0,0,0)                      // zera a hora 00:00:00
        return(date.getFullYear()+'/' + (date.getMonth()+1) + '/'+date.getDate())   
    }
    
    useEffect(() => {
            
        async function buscaAtestado() {
            await api.get('/atestado',{
            params: {           
                idPac: props.idPac
            }                
        }).then ( result => {

            result.data.sort((COD1, COD2) => {// ORDENA LISTA DO COMBO POR CODIGO.
                COD1 = COD1.CODIGO;
                COD2 = COD2.CODIGO;
    
                if (COD1 > COD2) {
                    return -1;
                }
                if (COD1 < COD2) {
                    return 1;
                } return 0;
            }) 

                result.data.map( (r) => {
                    r.DATA = transformaData(r.DATA)    
                })
                setAtestado(result.data);
                if (result.data[0]) {                                        
                    setCodAtestado(result.data[0].CODIGO);    
                    setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(result.data[0].TEXTOCONVERTIDO))));
                    setBtnCancelar(true) 
                    setDataBR(result.data[0].DATA)
                } else {
                    setBtnCancelar(true) 
                    
                }
    
        }).catch(
            (error) => {
            setMSG(logOut(error))
            setModalMSG(true)
            }
         )
    }
    
        async function buscaTexto(){
            await api.get('/textoportipo',{
                params: {           
                    tipoTexto: 11
                }                
            }).then ( result => {
                        setTexto(result.data)
                        if (result.data[0]) {
                            setCodTexto(result.data[0].CODIGO) 
                            }                               // para registrar o codTexto, pois select nao define codTexto 
                                                            //ao listar quando carrega tela.
            }).catch(
                (error) => {
                setMSG(logOut(error))
                setModalMSG(true)
                }
             )
        }
        
        buscaAtestado();
        buscaTexto();
        setLoading(false);
        setEdicao(true)
        setBtnCancelar(true)
    
    },[props.idPac]);
    
     async function handleNovoAtestado(){
               
        data.setHours(0,0,0,0) 
        
        setDisableData(true) //desativa o campo de data para não poder trocar
        setBtnCancelar(false)
        setEdicao(false)
        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(''))));
    
    //     await api.post('/atestado', {
    //             COD_PACIENTE: parseInt(props.idPac),
    //             DATA: transformaDataBanco(data),
    //             TEXTO: '<p></p>'
    //    })
    //    .catch(
    //     (error) => {
    //     setMSG(logOut(error))
    //     setModalMSG(true)
    //     }
    //  )
    
    //     await api.get('/atestado',{
    //             params: {           
    //                 idPac: props.idPac
    //             }                
    //     }).then ( result => {

    //         result.data.sort((COD1, COD2) => {// ORDENA LISTA DO COMBO POR CODIGO.
    //             COD1 = COD1.CODIGO;
    //             COD2 = COD2.CODIGO;
    
    //             if (COD1 > COD2) {
    //                 return -1;
    //             }
    //             if (COD1 < COD2) {
    //                 return 1;
    //             } return 0;
    //         }) 

    //                     result.data.map( r => {
    //                     r.DATA = transformaData(r.DATA)    
    //     })
    //     setAtestado(result.data);
    //     setCodAtestado(result.data[0].CODIGO);
    //     setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(''))));
    //     setDataTexto(transformaData(data))
    //     setBtnExcluir(false)

    // }).catch(
    //     (error) => {
    //     setMSG(logOut(error))
    //     setModalMSG(true)
    //     }
    //  )
    // setAuxStatus(true)
    }
    
    async function handleGravar(codRec){
    
            data.setHours(0,0,0,0) 
            await api.post('/atestado/', {
                COD_PACIENTE: parseInt(props.idPac),
                DATA: transformaDataBanco(data),
                TEXTO: sanitizeContent(textoBanco)
            }).then(
                    setMSG('Gravado'),
                    setModalMSG(true),
                    // setModalGravado(true)

                )
            .catch(    (error) => {
                setMSG(logOut(error))
                setModalMSG(true)
            })
    
    
        async function buscaAtestado() {
            await api.get('/atestado',{
                params: {           
                    idPac: props.idPac
                }                
        }).then ( result => {

            result.data.sort((COD1, COD2) => {// ORDENA LISTA DO COMBO POR CODIGO.
                COD1 = COD1.CODIGO;
                COD2 = COD2.CODIGO;
    
                if (COD1 > COD2) {
                    return -1;
                }
                if (COD1 < COD2) {
                    return 1;
                } return 0;
            }) 

                        result.data.map( r => {
                        r.DATA = transformaData(r.DATA)    
        })
        setAtestado(result.data);
        setDataBR(result.data[0].DATA)
        setCodAtestado(result.data[0].CODIGO);
        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(result.data[0].TEXTOCONVERTIDO))));
    
        }).catch(
                (error) => {
                setMSG(logOut(error))
                setModalMSG(true)
                }
            )
    }
        buscaAtestado();
        setDisableData(false) //Ativa o campo data para alterar, depois de gravado
        setBtnCancelar(true);
        setEdicao(true);

    }
    
    function handleCodAtestado(e) {
         setCodAtestado(e)
         atestado.map( atest => {
             if (parseInt(atest.CODIGO) === parseInt(e)) {
                    setDataTexto(atest.DATA)
                    setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(atest.TEXTOCONVERTIDO))));  
                    setDataBR(atest.DATA)
             }
            })
    }
    
async function handleAdicionaTexto(){


    const substituirVariaveis = (texto, nome, data) => {
        // Substitui todas as ocorrências de %nome e %data pelo nome e data fornecidos
        let textoModificado = texto.replace(/%nome/g, nome);
        textoModificado = textoModificado.replace(/%data/g, data);
        return textoModificado;
    };


    var textoAlterado;
    if ( typeof codTexto === 'undefined' ) {
        // alert('Selecione o Texto')
        setMSG('Selecione o Texto');
        setModalMSG(true)
        } else {
    texto.map( text => {
        if (parseInt(text.CODIGO) === parseInt(codTexto)) {
            textoAlterado = text.TEXTOCONVERTIDO
            textoAlterado = substituirVariaveis(textoAlterado,props.paciente,dataTexto)
            // textoAlterado = textoAlterado.replace("%nome", props.paciente)
            // textoAlterado = textoAlterado.replace("%data", dataTexto)
            onEditorStateChange(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(draftToHtml(convertToRaw(editorState.getCurrentContent())) +  textoAlterado ))));                         // VAI SER USADO PARA ADD TEXTO
        } 
    })
    }
    
    }
     
    function handleMostraModal(m){
         setMostraModal(m)
    }
    
    async function handleExcluirAtestado(cod){
        // await api.delete('/atestado/'+ parseInt(cod))
        // .then( 
        //     setMSG('Excluido!'),
        //     setModalMSG(true)
        
        // ).catch(    (error) => {
        //     setMSG(logOut(error))
        //     setModalMSG(true)
        // });
        setMostraModal(false);
        setDisableData(false)
        setBtnCancelar(true);
        setEdicao(true);
         
        await api.get('/atestado',{
            params: {           
                idPac: props.idPac
            }                
            }).then ( result => {
                if (result.data[0]) {
                    result.data.sort((COD1, COD2) => {// ORDENA LISTA DO COMBO POR CODIGO.
                    COD1 = COD1.CODIGO;
                    COD2 = COD2.CODIGO;
        
                    if (COD1 > COD2) {
                        return -1;
                    }
                    if (COD1 < COD2) {
                        return 1;
                    } return 0;
                }) 

                            result.data.map( r => {
                            r.DATA = transformaData(r.DATA)    
            })
            setAtestado(result.data);
            setDataBR(result.data[0].DATA)
            setCodAtestado(result.data[0].CODIGO);    
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(result.data[0].TEXTOCONVERTIDO))));
                } else {
                    setBtnCancelar(true)
                    setAtestado(result.data)
                    setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(''))));
                }    
        
        }).catch(
                (error) => {
                setMSG(logOut(error))
                setModalMSG(true)
                }
             )

    }
    
  

async    function chamaPDF(send){
        setBotaoEnv(true)
        var namePDF = 'AT'+props.paciente.toLowerCase();
        // let auxTexto = convertToRaw(editorState.getCurrentContent()).blocks
        // let texto =  auxTexto.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
        var docDefinitions; //ARQUIVO COM AS DEFINICOES DO ARQUIVO PDF
        var bufferPDF;      // ARQUIVO PDF GERADL PELO MAKE AQUI NO RECEITUARIO
        var assinatura;
        let rawContentState = convertToRaw(editorState.getCurrentContent()); 

        let html = draftToHtml(rawContentState); 
        html = convertListsToPdfMake(html);
        var texto = htmlToPdfMake(html);

        // console.log(html)
        // console.log(texto)

     // joga o lineHeight dentro do PDF em cada paragrafo.
    //  texto.forEach(element => { if (element.nodeName === 'P') { element.style = element.style || []; element.style.push({ lineHeight: 0.75 }); } });
     //remove a fonte
     // texto.forEach(element => { if (element.text) { element.font = element.font = ''; element.fontSize = '' } });
     // remove as linhas em branco abaixo
     texto = await removeBlankLines(texto);
     // remove fonte
     texto = await removeFontAttributes(texto)
 
        // console.log(texto)
    
        // Buscar dados completos do médico
        const buscaDadosMedico = async () => {
            try {
                const result = await api.get('/medico/', {params: {codigo: parseInt(props.idMed)}});
                return result.data;
            } catch (error) {
                setMSG(logOut(error));
                setModalMSG(true);
                return null;
            }
        };

        // Função para verificar se assinatura está vazia
        const isSignatureEmpty = (signature) => {
            if (!signature) return true;
            const emptyCanvas = document.createElement('canvas');
            emptyCanvas.width = 320;
            emptyCanvas.height = 200;
            const emptyDataURL = emptyCanvas.toDataURL();
            return signature === emptyDataURL || signature.length < 1000;
        };

        const medicoData = await buscaDadosMedico();
        if (medicoData && medicoData.ASSINATURA && !isSignatureEmpty(Buffer.from(medicoData.ASSINATURA).toString())) {
            assinatura = Buffer.from(medicoData.ASSINATURA).toString();
        }

       function pdf(){                     // CHAMA O ARQUIVO QUE CRIA AS DEFINICOES DO PDF E DEPOIS CRIA ELE AQUI
            return new Promise((res,rej)=>{
                docDefinitions = PrintReports(texto, props.nomeMed, props.paciente, props.titulo, dataBR, props.crmMed, medicoData?.CABECALHO, medicoData?.RODAPE, assinatura)  
                res()
            })
        }
    
        function geraBase64(){
            return new Promise((res,rej)=>{
                if (send) { pdfMake.createPdf(docDefinitions).getBuffer((buffer) => { // CRIA UM BUFFER E DEPOIS TRANSFORMA EM BASE64
                    bufferPDF = buffer.toString('base64')                           // QUE PODE SER ENVIADO PELA API MENUIA WHATSAPP
                        })} else { pdfMake.createPdf(docDefinitions).open();}
                res()
            })
        }
    
        function enviaZap(){
            return new Promise((res,rej)=>{
                if (send) {
                setTimeout(()=>                 // SETTIMEOUT PARA ESPERAR A FUNCAO DE CIMA TRABALHAR
                {
                      sendFile(props.celular,'Atestado',props.usuarioZap,namePDF,bufferPDF) // FUNCAO QUE ENVIAR O BASE64 PRO ZAP
                     setBotaoEnv(false)
                    
                },5000)}
                res()
            })
        }
        // CHAMA AS PROMISES, SÓ CONSEGUI ORGANIZAR QUEM EXECUTA PRIMEIRO COM PROMISES E TIMEOUT
        pdf().then(geraBase64().then(enviaZap()))
        setBotaoEnv(false)
    }

    function colaAtestado(){

        if (copiaAtestado) {
            setEditorState(copiaAtestado);
            setTextoBanco(draftToHtml(convertToRaw(copiaAtestado.getCurrentContent())));
        } else (  toast.error('Nenhum Atestado Copiado!', { style:{width:'300px', height:'70px',backgroundColor: '#c4defb',
        color: 'black',
        fontSize: '18px'}, duration: 3000}))
}

    async function previewPDF(){
        var docDefinitions;
        var assinatura;
        let rawContentState = convertToRaw(editorState.getCurrentContent()); 
        let html = draftToHtml(rawContentState); 
        html = convertListsToPdfMake(html);
        var texto = htmlToPdfMake(html);
        texto = await removeBlankLines(texto);
        texto = await removeFontAttributes(texto);

        // Buscar dados completos do médico
        const buscaDadosMedico = async () => {
            try {
                const result = await api.get('/medico/', {params: {codigo: parseInt(props.idMed)}});
                return result.data;
            } catch (error) {
                setMSG(logOut(error));
                setModalMSG(true);
                return null;
            }
        };

        // Função para verificar se assinatura está vazia
        const isSignatureEmpty = (signature) => {
            if (!signature) return true;
            const emptyCanvas = document.createElement('canvas');
            emptyCanvas.width = 320;
            emptyCanvas.height = 200;
            const emptyDataURL = emptyCanvas.toDataURL();
            return signature === emptyDataURL || signature.length < 1000;
        };

        const medicoData = await buscaDadosMedico();
        if (medicoData) {
            if (medicoData.ASSINATURA && !isSignatureEmpty(Buffer.from(medicoData.ASSINATURA).toString())) {
                assinatura = Buffer.from(medicoData.ASSINATURA).toString();
            }
            docDefinitions = PrintReports(texto, props.nomeMed, props.paciente, props.titulo, transformaData(data), props.crmMed, medicoData.CABECALHO, medicoData.RODAPE, assinatura);
        }

        const pdfDocGenerator = pdfMake.createPdf(docDefinitions);
        pdfDocGenerator.getBlob((blob) => {
            const url = URL.createObjectURL(blob);
            setPdfPreviewUrl(url);
        });
    }

    return(
        <div className="container-fluid" >  
            <br />
            <div className=" form-row">
                <div className="d-flex align-items-center">
                    <Button variant="primary" size="sm" disabled={!edicao} onClick={() => handleNovoAtestado()} >Novo</Button>                  
                    <span className="me-2"> </span> 
                    <Button variant="danger"  size="sm"  onClick={() => handleMostraModal(true)} disabled={btnCancelar}>Cancelar</Button>            
                    <span className="me-2"> </span> 
                    <Button variant="info" size="sm" onClick={() => edicao ? chamaPDF() : previewPDF()}>{edicao ? 'Imprimir' : 'Visualizar'}</Button>
                    <span className="me-2"> </span> 
                    <Button disabled={props.whatsapp || !edicao} size="sm" variant="success" onClick={()=>{setModalEnvia(true)}}><FontAwesomeIcon  icon={faWhatsapp} size='lg' /></Button>
                    <spam className="ms-auto d-flex align-items-center">
            <Button title="Copiar Atestado"  size="sm" variant="warning" onClick={()=> {setCopiaAtestado(editorState)
            toast.success('Atestado Copiado!', { style:{width:'250px', height:'70px',backgroundColor: '#c4defb',
            color: 'black',
            fontSize: '18px'}, duration: 3000})}} >
                <FontAwesomeIcon icon={faClone} size='lg' />
            </Button>
            <span className="ms-2"> </span>
            <Button title="Colar Atestado" size="sm" variant="warning" onClick={()=> {colaAtestado()}} >
                <FontAwesomeIcon icon={faPaste} size='lg' />
            </Button>
            </spam>  
                </div>
            <div className=" row">
                <div className="col-md-2">
                    Atestado Emitidos:
                    {!disableData && <Form.Control  size="sm" as="select" 
                    value={codAtestado} 
                    onChange={e => handleCodAtestado(e.target.value)} 
                    disabled={disableData} >                               
                                        {atestado.map( atest => (
                                            <option key={atest.CODIGO} value={atest.CODIGO}>{DOMPurify.sanitize(atest.DATA)}</option>
                                            ))}
                    </Form.Control>}
                    {disableData && <Form.Control  size="sm" as="select" 
                    value={codAtestado} 
                    onChange={e => handleCodAtestado(e.target.value)} 
                    disabled={disableData} >                               
                      
                                            <option>{transformaData(data)}</option>
                      
                    </Form.Control>}
                </div>
                
                <div className="col-md-2">
                    Texto:
                    <Form.Control  size="sm" as="select" 
                    value={codTexto} 
                    onChange={e => setCodTexto(e.target.value)} >                               
                                        {texto.map( text => (
                                            <option key={text.CODIGO} value={text.CODIGO}>{DOMPurify.sanitize(text.NOME)}</option>
                                            ))}
                    </Form.Control> 
                </div>
                <div className="col-md-2">
                    <br />
                    <Button variant="success" disabled={btnCancelar} size="sm" onClick={m => handleAdicionaTexto()} >Adicionar Texto</Button>
                </div>
             </div>   
            </div>
            <div className=" btn-group-vertical col-md-12 ">
                <div className="editor-container" style={{backgroundColor:'white',width:'100%'}}>
                    <Editor 
                            editorState={editorState}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={onEditorStateChange}
                            placeholder="Digite o Texto"
                            toolbar={toolBarValues}
                            readOnly={edicao}
                            toolbarStyle={{position: 'sticky', top: 0, zIndex: 1000, backgroundColor: 'white'}}
                            editorStyle={{height: '500px', overflow: 'auto'}}
                        />
                </div>
            </div>
            <br />
            <div className=" btn-group-vertical col-md-1">
                <Button variant="primary" disabled={edicao}  onClick={() => handleGravar(codAtestado)}>Gravar</Button>
            </div>
    
            <Modal show={mostraModal}>
                <Modal.Header> 
                    <h3>Cancelar o Atestado?</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="danger" onClick={() => handleExcluirAtestado(codAtestado)}>Sim</Button>
                    <Button variant="info" onClick={() => handleMostraModal(false)}>Não</Button>
                </Modal.Footer>
    
            </Modal>
            <Modal show={modalGravado}>
                <Modal.Header> 
                    <h3>Gravado!</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalGravado(false)}>Ok</Button>
                </Modal.Footer>
            </Modal> 
            <Modal show={modalMSG}>
                <Modal.Header> 
                    <h3>{MSG}</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalMSG(false)}>Ok</Button>
                </Modal.Footer>
            </Modal>  
            <Modal show={loading}>
               <Modal.Body>
                Aguarde....
                </Modal.Body>
        </Modal>  
        <Modal show={modalEnviar}>
                <Modal.Header> 
                    <h3>Enviar WhatsApp com Pedido de Exame</h3>
                </Modal.Header> 
                <Modal.Footer> 
                {botaoEnv ? <>Enviando...<Spinner /></> : 
                    <>
                    <Button variant="info" onClick={() => { chamaPDF(true)
                                                            setBotaoEnv(true)}}>Enviar</Button>
                    <Button variant="danger" onClick={() => {setModalEnvia(false)}}>Fechar</Button>
                    </>}
                </Modal.Footer>
            </Modal>

            <Modal show={pdfPreviewUrl !== null} size="lg" centered onHide={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null);}}>
                <Modal.Header closeButton> 
                    <h3>Visualização do Atestado</h3>
                </Modal.Header> 
                <Modal.Body>
                    {pdfPreviewUrl && <iframe src={pdfPreviewUrl + '#toolbar=0'} style={{width: '100%', height: '600px', border: 'none'}} title="Preview PDF"></iframe>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null);}}>Fechar</Button>
                </Modal.Footer>
            </Modal> 
        </div>
    )

}